import * as React from "react";
const SvgMinusLarge = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M19 11.125a.875.875 0 0 1 0 1.75H5a.875.875 0 0 1 0-1.75z" /></svg>;
export default SvgMinusLarge;